import { type PreviewConfig } from '../types.js';

export const previewConfig: PreviewConfig = {
  images: {
    set: {
      dawn: 'set_01',
      dusk: 'set_01',
      midday: 'set_03',
      midnight: 'set_03',
      morning: 'set_02',
    },
    useHighRes: false,
  },
  projects: {
    quantity: 3,
  },
  services: {
    quantity: 3,
  },
};
